import { useEffect } from 'react'

import { useBucket } from '@mc/experiments-react'
import { EventTypes, getPageSource, track } from '@mc/track-event'

// SRM mismatch bucketing https://ourmasterclass.slack.com/archives/C031TCWLMEJ/p1745929509475639?thread_ts=1745852741.519289&cid=C031TCWLMEJ
export const useTrackExperimentViewedFE = (experimentName: string) => {
  const bucket = useBucket(experimentName)

  useEffect(() => {
    const experimentBucketFired = getExperimentBucket(experimentName)

    if (bucket && !experimentBucketFired) {
      track(EventTypes.EXPERIMENT_VIEWED, {
        experimentName: `${experimentName}_fe`,
        variationName: bucket,
        page_source: getPageSource(),
      })

      saveExperimentBucket(experimentName)
    }
  }, [bucket, experimentName])
}

const saveExperimentBucket = (experimentName: string) => {
  // "replicate" similar behavior to trackExerimentViewed which is fired once.
  if (process.env.NODE_ENV === 'production') {
    window.sessionStorage.setItem(experimentName, 'true')
  }
}

const getExperimentBucket = (experimentName: string) =>
  window.sessionStorage.getItem(experimentName)
